import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL + '/features';
function params(method, body) {
  let header = {};
  if (body) {
    header = {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json',
    };
    body = JSON.stringify(body);
    return { method: method, headers: header, body: body };
  } else {
    header = { Authorization: `Bearer ${localStorage.getItem('token')}` };
    return { method: method, headers: header };
  }
}

const FeaturesService = {
  async upsertFeature({ name, description, default_state }) {
    try {
      const url = `${API_BASE}/admin/upsert`;
      const normalizedState = default_state === 'on' ? 1 : 0;
      const body = {
        name,
        description,
        normalizedState,
      };

      const upsertEntry = await fetch(url, params('POST', body));

      if (upsertEntry.ok) {
        const respond = await upsertEntry.json();
        return respond;
      } else {
        console.error('Error upserting feature');
        return null;
      }
    } catch (err) {
      console.error(err);
    }
  },

  async saveFeatureRule(featureName, rule) {
    try {
      const body = {
        feature_name: featureName,
        rule_ref_field: rule.rule_ref_field,
        rule_type: rule.rule_type,
        rule_value: rule.rule_value,
        rule_order: rule.rule_order ?? 0,
        is_enabled: rule.is_enabled ?? 1,
      };

      const url = `${API_BASE}/admin/rule`;
      const res = await fetch(url, params('POST', body));

      if (!res.ok) throw new Error('Failed to save rule');

      const result = await res.json();
      return result;
    } catch (err) {
      console.error('saveFeatureRule error:', err);
      return null;
    }
  },

  async saveFeatureException(feature_id, exception) {
    try {
      const url = `${API_BASE}/admin/exception`;
      const body = {
        feature_id,
        type: exception.type,
        value: exception.value,
        override_state: exception.override_state === 'on' || exception.override_state === 1 ? 1 : 0,
      };

      const res = await fetch(url, params('POST', body));
      if (res.ok) {
        const data = await res.json();
        return data.exception;
      } else {
        console.error('Failed to save exception');
        return null;
      }
    } catch (err) {
      console.error(err);
    }
  },

  // Get list of users with access to a specific feature
  async getUsersForFeature(featureName) {
    try {
      const url = `${API_BASE}/admin/${featureName}/users`;
      const userList = await fetch(url, params('GET'));

      if (userList.ok) {
        const respond = await userList.json();
        return respond;
      } else {
        console.error('Error fetching user list');
        return [];
      }
    } catch (err) {
      console.error(err);
    }
  },

  // Check if a feature is enabled for the current user
  async isFeatureEnabled(feature_name) {
    try {
      const url = `${API_BASE}/check`;
      const enabled = await fetch(url, params('POST', { featureName: feature_name }));

      if (enabled.ok) {
        const respond = await enabled.json();
        return respond.enabled;
      } else {
        console.error('Error fetching feature status');
        return false;
      }
    } catch (err) {
      console.error(err);
    }
  },

  // (Optional) Get all features for admin listing
  async getAllFeatures() {
    try {
      const url = `${API_BASE}/admin/all`;
      const featureList = await fetch(url, params('GET'));

      if (featureList.ok) {
        const respond = await featureList.json();
        return respond.features || [];
      } else {
        console.error('Error fetching feature list');
        return [];
      }
    } catch (err) {
      console.error(err);
    }
  },

  async deleteFeature(id) {
    try {
      const url = `${API_BASE}/admin/delete/${id}`;
      const featureDeleted = await fetch(url, params('DELETE'));

      if (featureDeleted.ok) {
        const respond = await featureDeleted.json();
        return respond;
      } else {
        console.error('Error deleting feature');
        return null;
      }
    } catch (err) {
      console.error(err);
    }
  },

  async deleteFeatureRule(ruleId) {
    try {
      const url = `${API_BASE}/admin/rule/${ruleId}`;
      const res = await fetch(url, params('DELETE'));

      const data = await res.json();
      return data.success;
    } catch (error) {
      console.error('Failed to delete rule:', error);
      return false;
    }
  },

  async assignUserToFeature(userId) {
    try {
      const url = `${API_BASE}/admin/assign-user`;
      const res = await fetch(url, params('POST', { user_id: userId }));
      if (!res.ok) throw new Error('Failed to assign user');
      return await res.json();
    } catch (err) {
      console.error('assignUserToFeature error:', err);
      return null;
    }
  },

  async deleteFeatureException(id) {
    try {
      const url = `${API_BASE}/admin/exception/${id}`;
      const res = await fetch(url, params('DELETE'));

      if (res.ok) {
        return true;
      } else {
        console.error('Failed to delete exception');
        return false;
      }
    } catch (err) {
      console.error('Error deleting exception:', err);
      return false;
    }
  },
};

export default FeaturesService;
